import type { FrameStyleId, FrameWeightId } from "../../shared/game";
import { FRAME_STYLES, FRAME_WEIGHTS } from "../../constants/editor";
import { FramePreview } from "../card/FramePreview";

type FrameControlsProps = {
  frameStyle: FrameStyleId;
  setFrameStyle: (style: FrameStyleId) => void;
  frameWeight: FrameWeightId;
  setFrameWeight: (weight: FrameWeightId) => void;
  autoColor: string;
  frameColorManual: string | null;
  setFrameColorManual: (color: string | null) => void;
  disabled?: boolean;
};

export function FrameControls({
  frameStyle,
  setFrameStyle,
  frameWeight,
  setFrameWeight,
  autoColor,
  frameColorManual,
  setFrameColorManual,
  disabled = false,
}: FrameControlsProps) {
  const frameColor = frameColorManual ?? autoColor;

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6, marginBottom: 12 }}>
        {FRAME_STYLES.map((entry) => (
          <button key={entry.id} type="button" disabled={disabled} onClick={() => setFrameStyle(entry.id)} style={{ border: "none", background: "transparent", color: "inherit", opacity: disabled ? 0.5 : 1, padding: 0 }}>
            <FramePreview frameStyle={entry.id} color={frameColor} selected={frameStyle === entry.id} />
            <div style={{ marginTop: 4, fontSize: 9, color: frameStyle === entry.id ? frameColor : "#7c8399" }}>{entry.name}</div>
          </button>
        ))}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <button
          type="button"
          disabled={disabled}
          onClick={() => setFrameColorManual(null)}
          style={{
            width: 30,
            height: 30,
            borderRadius: 8,
            border: `2px solid ${frameColorManual === null ? "#fff" : "rgba(255,255,255,0.15)"}`,
            background: `linear-gradient(135deg, ${autoColor}, ${autoColor}88)`,
          }}
        />
        <input disabled={disabled} type="color" value={frameColor} onChange={(event) => setFrameColorManual(event.target.value)} style={{ width: 34, height: 30 }} />
        <div style={{ fontSize: 11, color: "#9399ac" }}>{frameColorManual ? "Custom frame colour" : "Frame follows type colour"}</div>
      </div>

      <div style={{ display: "flex", gap: 6 }}>
        {FRAME_WEIGHTS.map((entry) => (
          <button
            key={entry.id}
            type="button"
            disabled={disabled}
            onClick={() => setFrameWeight(entry.id)}
            className={frameWeight === entry.id ? "active-button" : "ghost-button"}
            style={{ flex: 1, padding: "8px 4px" }}
          >
            {entry.label}
          </button>
        ))}
      </div>
    </>
  );
}
